export default "__VITE_ASSET__yDieWZnb__"